
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/press_release",
      function () {
        return require("private-next-pages/node/press_release.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/press_release"])
      });
    }
  